import React from 'react';

const Artificial = () => {
	return <div>this page is under construction</div>;
};

export default Artificial;
